const FaqRoutes = {
  getFaqs: 'faq',
};

export default FaqRoutes